const stepGroups = document.querySelectorAll('.step-group');

if (stepGroups) {

	window.addEventListener('load', () => {
		let section = window.location.pathname.split("/").pop();

		const targetSection = document.getElementById(section);

		if (targetSection) {
			targetSection.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest"
			});
		}
	})
}